<template>
  <div>
    <PlatformTemplate :platform="platform" :games="games" @go-to-game="goToGame"></PlatformTemplate>
  </div>
</template>

<script>
  import axios from 'axios';
  import api from '@/api';
  import PlatformTemplate from '../components/templates/PlatformTemplate';

  export default {
    components: {
      PlatformTemplate,
    },

    data: () => ({
      games: [],
    }),
    mounted() {
      axios.get(`${api.endpoint}/platforms/${this.platform}/games`).then(response => (this.games = response.data));
    },
    computed: {
      platform() {
        return this.$route.params.platform;
      },
    },
    methods: {
      goToGame(id) {
        this.$router.push({ name: 'game', params: { id } });
      },
    },
  };
</script>
